<div [class]="labelAndFieldContainerClasses">
  <label
    class="tw-flex tw-items-center tw-gap-0.5 tw-text-sm/5 tw-font-medium tw-max-w-full"
    [attr.for]="input()?.labelForId()"
  >
    <ng-content select="bit-label"></ng-content>
    @if (input()?.required()) {
      <sup class="tw-text-sm/5 tw-text-fg-danger tw-relative tw-top-[-1px]">*</sup>
      <span class="tw-sr-only"> ({{ "required" | i18n }})</span>
    }
  </label>
  @if (customInput()) {
    <!-- Wrapper mode: the composing component lays out its own control in this slot. -->
    <ng-content select="[bitCustomInput]"></ng-content>
  } @else {
    <div class="tw-flex tw-gap-2 tw-items-center">
      <div bitFieldContainer [size]="size()" [hasError]="input()?.hasError()" [readOnly]="readOnly">
        <div
          #prefixContainer
          [hidden]="!prefixHasChildren()"
          class="tw-flex tw-items-center tw-border-e tw-border-border-base tw-px-3 tw-bg-bg-quaternary tw-rounded-s-[11px]"
        >
          <ng-content select="[bitPrefix]"></ng-content>
        </div>
        <div
          class="tw-flex tw-w-full tw-items-center tw-pe-3 has-[[biticonbutton]:last-child]:tw-pe-1 has-[bit-select]:tw-pe-0 has-[select]:tw-pe-0 has-[bit-multi-select]:tw-pe-0 has-[textarea]:!tw-items-start has-[bit-file-name]:tw-min-w-0"
        >
          <div [class]="contentContainerClasses" data-default-content>
            <ng-content></ng-content>
          </div>
          <div
            #suffixContainer
            [hidden]="!suffixHasChildren()"
            class="tw-flex tw-items-center group-has-[textarea]/form-field:tw-pt-1"
          >
            <ng-content select="[bitSuffix]"></ng-content>
          </div>
        </div>
      </div>
      <ng-content select="[slot='inline-end']"></ng-content>
    </div>
  }
  @switch (input()?.hasError()) {
    @case (false) {
      <ng-content select="bit-hint"></ng-content>
    }
    @case (true) {
      <bit-error [error]="input()?.error"></bit-error>
    }
  }
</div>
